// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { PageInfoProps, PageInputProps } from '../../../interfaces'
import { LoteProps } from '../interfaces'
import { LoteFragment } from '../interfaces/fragment'

const gqlQuery = gql`
  ${LoteFragment}
  query LOTE($limit: Int!, $reverse: Boolean, $page: Int!, $query: String) {
    loteListado(limit: $limit, reverse: $reverse, page: $page, query: $query) {
      pageInfo {
        totalPages
      }
      docs {
        ...field
      }
    }
  }
`

interface LoteResponse {
  pageInfo: PageInfoProps
  docs: LoteProps[]
}

export const apiLote = async (pageInfo: PageInputProps): Promise<LoteResponse> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)
  const data: any = await client.request(gqlQuery, { ...pageInfo })
  return data.loteListado
}
